// Sidebar entries owned by the Report module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { SidebarType } from '@/types/shared'
import { resources, scopes } from '@/utils/permission'
import { reportPaths } from './paths'

export const reportNav = {
    customer: {
        title: 'report:sidebar_customer',
        path: reportPaths.reportCustomer,
        rsname: resources.reports,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
    service: {
        title: 'report:sidebar_service',
        path: reportPaths.reportService,
        rsname: resources.reports,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
    income: {
        title: 'report:sidebar_income',
        path: reportPaths.reportIncome,
        rsname: resources.reports,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
    revenues: {
        title: 'report:sidebar_revenues',
        path: reportPaths.reportRevenue,
        rsname: resources.reports,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
    businessTargets: {
        title: 'report:sidebar_business_targets',
        path: reportPaths.reportBusinessTargets,
        rsname: resources.reports,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
    targetsAnalytics: {
        title: 'report:sidebar_targets_analytics',
        path: reportPaths.reportTargetAnalytics,
        rsname: resources.reports,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
    financials: {
        title: 'report:sidebar_financials',
        path: reportPaths.reportFinance,
        rsname: resources.reports,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
    serviceAnalytics: {
        title: 'report:sidebar_service_analytics',
        path: reportPaths.reportAnalytics,
        rsname: resources.reports,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
    vpbank: {
        title: 'report:sidebar_vpbank',
        path: reportPaths.reportVpbank,
        rsname: resources.reports,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
    receivables: {
        title: 'report:sidebar_receivables',
        path: reportPaths.reportReceivables,
        rsname: resources.reports,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
} satisfies Record<string, SidebarType>
